import { render, staticRenderFns } from "./anchorEdit.vue?vue&type=template&id=229e7dbe&scoped=true&"
import script from "./anchorEdit.vue?vue&type=script&lang=js&"
export * from "./anchorEdit.vue?vue&type=script&lang=js&"
import style0 from "./anchorEdit.vue?vue&type=style&index=0&id=229e7dbe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229e7dbe",
  null
  
)

export default component.exports